/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { baseApiService } from './base'

const baseURL = 'api/watermarks'
const baseURL_v2 = 'api/v2/watermarks'

interface GetAllRequestType {
  id: number[]
  pageSize: number
  pageStart: number
  sortBy: string
  sortDesc: boolean
  _noLoadingSpinner: boolean
}

interface CreateWatermarkRequestType {
  stampText?: string
  foregroundColor?: string
  description?: string
  name?: string
  fontSize?: number
  fontStyle?: number
  verticalAlignment?: number
  horizontalAlignment?: number
  textAlignment?: number
  rotateAngle?: number
  opacity?: string
}

class WatermarksApiService {
  async getAll(params: GetAllRequestType) {
    return baseApiService.fetch(baseURL_v2, {
      method: 'GET',
      params: { ...params }
    })
  }

  async getOptionsForAsyncPicker(search: string, pageStart: number) {
    const params = {
      name: search ? search : null,
      pageStart,
      pageSize: 25
    }

    const req = baseApiService.fetch(baseURL_v2 + '/picker', {
      method: 'GET',
      params: { ...params }
    })
    // USE FILTER SERVICE HERE
    // return filterService.processAsyncPickerRequest(req, params);
    return req
  }

  // async create(data: CreateWatermarkRequestType, hideLoader: boolean) {
  async create(data: CreateWatermarkRequestType) {
    return baseApiService.fetch(baseURL, {
      method: 'POST',
      body: { ...data }
    })
  }

  // async remove(watermarkId: number, hideLoader: boolean) {
  async remove(watermarkId: number) {
    return baseApiService.fetch(baseURL + '/' + watermarkId, {
      method: 'DELETE'
    })
  }

  // async update(watermarkId: number, data: any, hideLoader: boolean) {
  async update(watermarkId: number, data: CreateWatermarkRequestType) {
    return baseApiService.fetch(baseURL + '/' + watermarkId, {
      method: 'PUT',
      body: { ...data }
    })
  }

  // async getById(watermarkId: number, hideLoader: boolean) {
  async getById(watermarkId: number) {
    // VERIFY THE URL HERE
    return baseApiService.fetch(baseURL + '/' + watermarkId)
  }

  // async getUsageById(watermarkId: number, hideLoader: boolean) {
  async getUsageById(watermarkId: number) {
    return baseApiService.fetch(baseURL + '/' + watermarkId + '/usage')
  }

  getAvailableTypes(type: string) {
    //UPDATE WITH CORRECT TRANSLATE FILTER

    let types: { id: number; value: string }[] = []

    switch (type) {
      case 'horizontalAlignment':
      case 'textAlignment':
        types = [
          // {id: 0, value: 'None'},
          { id: 1, value: this.getTranslationKey('OPTION_LEFT') },
          { id: 2, value: this.getTranslationKey('OPTION_CENTER') },
          { id: 3, value: this.getTranslationKey('OPTION_RIGHT') }
          // {id: 4, value: 'Justify'},
          // {id: 5, value: 'Full Justify'}
        ]
        break
      case 'verticalAlignment':
        types = [
          // {id: 0, value: 'None'},
          { id: 1, value: this.getTranslationKey('OPTION_TOP') },
          { id: 2, value: this.getTranslationKey('OPTION_CENTER') },
          { id: 3, value: this.getTranslationKey('OPTION_BOTTOM') }
        ]
        break
      case 'fontStyle':
        types = [
          { id: 0, value: this.getTranslationKey('OPTION_REGULAR') },
          { id: 1, value: this.getTranslationKey('OPTION_BOLD') },
          { id: 2, value: this.getTranslationKey('OPTION_ITALICS') },
          { id: 3, value: this.getTranslationKey('OPTION_BOLDITALICS') }
        ]
        break
      case 'fontSize':
        types = [
          { id: 8, value: this.getTranslationKey('N_PX', { value: 8 }) },
          { id: 10, value: this.getTranslationKey('N_PX', { value: 10 }) },
          { id: 12, value: this.getTranslationKey('N_PX', { value: 12 }) },
          { id: 14, value: this.getTranslationKey('N_PX', { value: 14 }) },
          { id: 16, value: this.getTranslationKey('N_PX', { value: 16 }) },
          { id: 18, value: this.getTranslationKey('N_PX', { value: 18 }) },
          { id: 20, value: this.getTranslationKey('N_PX', { value: 20 }) },
          { id: 24, value: this.getTranslationKey('N_PX', { value: 24 }) },
          { id: 28, value: this.getTranslationKey('N_PX', { value: 28 }) },
          { id: 32, value: this.getTranslationKey('N_PX', { value: 32 }) },
          { id: 36, value: this.getTranslationKey('N_PX', { value: 36 }) },
          { id: 48, value: this.getTranslationKey('N_PX', { value: 48 }) },
          { id: 72, value: this.getTranslationKey('N_PX', { value: 72 }) },
          { id: 96, value: this.getTranslationKey('N_PX', { value: 96 }) },
          { id: 110, value: this.getTranslationKey('N_PX', { value: 110 }) },
          { id: 146, value: this.getTranslationKey('N_PX', { value: 146 }) }
        ]
        break
    }

    return types
  }

  getTranslationKey(str: string, value?: { value: number }) {
    return value ? str + '_' + value?.value : str
  }
}

export const watermarksApiService = new WatermarksApiService()
